var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup164(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4885 32.4795C23.5558 39.2537 27.8911 51.3505 35.8776 54.4956",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4609 26.189C53.6754 29.818 56.4136 39.4954 51.3936 48.9309",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1865 44.5761H11.9184M26.0656 53.2858C26.0656 53.2858 17.1665 53.2858 11.6902 53.2858C6.21388 53.2858 6.21388 44.5761 11.462 44.5761C11.6446 44.5761 11.8423 44.5761 11.9184 44.5761M11.9184 44.5761C11.9184 44.5761 17.5192 44.7234 11.6902 44.5761C5.86122 44.4289 5.8594 35.725 11.6902 35.8665M11.6902 35.8665H22.5248M11.6902 35.8665C5.84591 35.8665 5.9857 27.1568 11.6902 27.1568M11.6902 27.1568H26.9783M11.6902 27.1568C6.44206 27.1568 6.21388 18.2052 11.6902 18.2052H20.361M44.5481 21.1084C44.6015 20.7556 44.3716 18.5599 42.2663 18.241M42.2663 18.241C42.0572 18.2093 41.8295 18.1962 41.5818 18.2052H20.361M42.2663 18.241C42.2663 18.241 44.0918 18.241 49.1117 18.241C54.1317 18.241 53.4471 9.73751 49.1117 9.73751C49.1117 9.73751 42.4456 9.73751 35.421 9.73751M20.361 9.73751C15.1129 9.73751 16.0256 18.2052 20.361 18.2052M20.361 9.73751C20.361 9.73751 13.5156 9.73751 6.89841 9.73751C0.281242 9.73751 0.281271 1.02783 6.89841 1.02783C6.89841 1.02783 30.401 1.02783 35.421 1.02783C40.4409 1.02783 42.2663 9.73751 35.421 9.73751M20.361 9.73751C22.8142 9.73751 29.2556 9.73751 35.421 9.73751",
    stroke: "#006D77",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5081 31.9956H36.7899M45.6889 31.9956H36.7899M34.5081 36.1085H45.6889M36.7899 31.9956C43.1789 31.9956 42.7225 41.1892 35.1926 41.1892L43.1789 48.2053",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8972 20.8828C51.1795 20.8828 59.5641 29.7295 59.5642 40.7051C59.5642 51.6808 51.1796 60.5283 40.8972 60.5283C30.6149 60.5282 22.2302 51.6807 22.2302 40.7051C22.2304 29.7296 30.615 20.8829 40.8972 20.8828Z",
    stroke: "#006D77"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.072,
    cy: 55.2211,
    rx: 1.36908,
    ry: 1.45161,
    fill: "#006D77"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.2665,
    cy: 26.1894,
    rx: 1.36908,
    ry: 1.45161,
    fill: "#006D77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup164);
export default __webpack_public_path__ + "static/media/Group 164.a948f82ed194af7a3f3af5d388ef8b6a.svg";
export { ForwardRef as ReactComponent };